<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("usersshift", 2) }}
      </div>
      <router-link class="btn-blue" to="user-shifts"
        >{{ $tc("usersshift", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="edit-movie-container">
      <form>
        <div class="row">
          <!-- CINEMAS SELECTION -->

          <div class="col-md-4 mb-4">
            <div
              v-if="userInfo.cinema_id !== 0"
              class="dropdown-curve-container"
            >
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
                $tc("cinema", 1)
              }}</label>
              <!-- :disabled="isRoleID" -->
              <b-dropdown
                disabled
                :text="selectedCinema"
                v-model="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                name="selectcinema-1"
                id="selectcinema-1"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">{{
                messagecinema
              }}</span>
            </p>
          </div>

          <!-- <div class="col-md-6 mb-4">
            <div class="dropdown-curve-container">
              <label
                :class="selected.Concession.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('concession', 1) }}</label>
              <div class="dropdown-curve-container">
                <b-dropdown :text="selected.Concession" variant="dropdown-curve" class="w-100">
                  <b-dropdown-item
                    v-for="(concession, concessionIndex) in Concessions"
                    :key="concessionIndex"
                    @click="onSelectConcession(concession)"
                    name="selectconcession"
                    id="selectconcession"
                  >{{ concession.cl_name }}</b-dropdown-item>
                </b-dropdown>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>
          </div>-->

          <!-- SELECT STORE  -->
          <!-- <div class="col-md-6 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedStoreLevel.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("store", 1) }}</label
              >
              <b-dropdown
                :text="selectedStoreLevel"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Store"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchStore()"
                    v-on:keydown="onSearchStore()"
                    v-on:search="onSearchStore()"
                    v-model="searchStore"
                  />
                </div>
                <b-dropdown-item
                  v-for="(Item, ItemIndex) in storeManagementsLevels"
                  :key="ItemIndex"
                  v-on:click="onSelectStore(Item)"
                  >{{ Item.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <p class="error_message">
              <span v-if="submitted && users_shifts.sm_id.length == 0"
                >Please Select Store.</span
              >
            </p>
          </div> -->

          <!-- <div class="col-md-6 mb-4">
            <div v-if="userInfo.cinema_id !== 0" class="dropdown-curve-container">
              <label class="shift-up">Select Cinema</label>
              <b-dropdown
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
                name="selectcinema-1"
                id="selectcinema-1"
                v-validate="'required'"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedCinema == 'Select Cinema'"
              class="error_message"
            >{{ messagecinema }}</p>
          </div>-->

          <div class="col-md-4 mb-4">
            <div
              v-if="userInfo.cinema_id !== 0"
              class="dropdown-curve-container"
            >
              <label :class="selectedUser.length > 0 ? 'shift-up' : ''">
                {{ $tc("user", 1) }}</label
              >
              <b-dropdown
                disabled
                :text="selectedUser"
                variant="dropdown-curve"
                class="w-100"
                name="selectuser"
                id="selectuser"
              >
                <b-dropdown-item
                  v-for="(user, userIndex) in Users"
                  :key="userIndex"
                  v-on:click="onSelectUser($event, user)"
                  >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <p class="error_message">
              <span v-if="submitted && selectedUser.length == 0">{{
                messageuser
              }}</span>
            </p>
          </div>

          <!-- <div class="col-md-6 mb-4">
            <div class="dropdown-curve-container">
              <label class="shift-up">Select User</label>
              <b-dropdown
                :text="selectedUser"
                variant="dropdown-curve"
                class="w-100"
                name="selectuser"
                id="selectuser"
                v-validate="'required'"
              >
                <b-dropdown-item
                  v-for="(user, userIndex) in Users"
                  :key="userIndex"
                  v-on:click="onSelectUser($event, user)"
                >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedUser == 'Select User'"
              class="error_message"
            >{{ messageuser }}</p>
          </div>-->

          <div class="col-md-4 mb-4">
            <div
              v-if="userInfo.cinema_id !== 0"
              class="dropdown-curve-container"
            >
              <label :class="selectedShift.length > 0 ? 'shift-up' : ''">{{
                $tc("shift", 1)
              }}</label>
              <b-dropdown
                :text="selectedShift"
                variant="dropdown-curve"
                class="w-100"
                name="selectshift"
                id="selectshift"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Shift"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchShift()"
                    v-on:keydown="onSearchShift()"
                    v-on:search="onSearchShift()"
                    v-model="searchShift"
                  />
                </div>
                <b-dropdown-item
                  v-for="(shift, shiftIndex) in Shifts"
                  :key="shiftIndex"
                  v-on:click="onSelectShift($event, shift)"
                  >{{ shift.shift_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <p class="error_message">
              <span v-if="submitted && selectedShift.length == 0">{{
                messageshift
              }}</span>
            </p>
          </div>

          <!-- <div class="col-md-6 mb-4">
            <div class="dropdown-curve-container">
              <label class="shift-up">Select Shift</label>
              <b-dropdown
                :text="selectedShift"
                variant="dropdown-curve"
                class="w-100"
                name="selectshift"
                id="selectshift"
                v-validate="'required'"
              >
                <b-dropdown-item
                  v-for="(shift, shiftIndex) in Shifts"
                  :key="shiftIndex"
                  v-on:click="onSelectShift($event, shift)"
                >{{ shift.shift_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedShift == 'Select Shift'"
              class="error_message"
            >{{ messageshift }}</p>
          </div>-->

          <div class="col-md-4 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="users_shifts.us_start_date"
                    v-on:click="clear_us_start_date()"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="users_shifts.us_start_date"
                    name="shiftstart-1"
                    id="shiftstart-1"
                    :typeable="true"
                    v-validate="'required'"
                  ></Datepicker>
                  <label
                    :class="
                      typeof users_shifts.us_start_date === 'object'
                        ? 'active'
                        : ''
                    "
                    >{{ $t("shiftstartdate") }}</label
                  >
                </div>
                <p class="error_message">
                  <span v-if="submitted && users_shifts.us_start_date === ''"
                    >Please enter shift start date</span
                  >
                </p>
              </div>
              <!-- <Tooltip :title="$t('us_start_date')" /> -->
            </div>
          </div>

          <div class="col-md-4 mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="users_shifts.us_end_date"
                    v-on:click="clear_us_end_date()"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="users_shifts.us_end_date"
                    name="shiftend-1"
                    id="shiftend-1"
                    :typeable="true"
                    v-validate="'required'"
                  ></Datepicker>
                  <label
                    :class="
                      typeof users_shifts.us_end_date === 'object'
                        ? 'active'
                        : ''
                    "
                    >{{ $t("shiftenddate") }}</label
                  >
                </div>
                <p class="error_message">
                  <span v-if="submitted && users_shifts.us_end_date === ''"
                    >Please enter shift end date</span
                  >
                </p>
              </div>
              <!-- <Tooltip :title="$t('us_end_date')" /> -->
            </div>
          </div>

          <div class="col-md-4 mb-4">
            <div class="d-flex align-items-center pt-3">
              <div class="mr-3">
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
              <div class>
                <div>
                  <b-form-checkbox
                    unchecked-value="N"
                    value="Y"
                    v-model="users_shifts.us_is_active"
                    name="check-button"
                    class="j-checkbox"
                    switch
                  ></b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              class="btn-blue"
              @click.prevent.stop="handleSubmit(true)"
            >
              {{ $t("update") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="handleSubmit(false)"
              type="submit"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <!-- <button class="btn-black">{{ $t('reset') }}</button> -->
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="user-shifts"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Shifts from "@/helper/formJSONMaster/Shifts";

export default {
  data() {
    return {
      btenable: false,
      selected: {
        Concession: "",
      },
      isRoleID: true,
      messagecinema: "Please Select Cinema.",
      messageuser: "Please Select User.",
      messageshift: "Please Select Shift",
      users_shifts: {
        // cinema_id: "",
        concession_level_id: null,
        sm_id: "",
        user_id: "",
        shift_id: "",
        us_start_date: "",
        us_end_date: "",
        us_is_active: true,
        us_id: "",
      },
      Cinemas: [],
      Concessions: [],

      Users: [],
      Shifts: [],
      selectedCinema: "",
      storeManagementsLevels: [],
      selectedStoreLevel: "",
      selectedUser: "",
      selectedShift: "",
      userInfo: {},
      Shifts: Shifts.ms_shifts,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Shifts.Methods,
      storeManagementsLevelsCopy: [],
      searchStore: "",
      ShiftsCopy: [],
      searchShift: "",
    };
  },
  beforeMount() {
    this.users_shifts.us_id = this.$route.query.us_id;
  },
  mounted() {
    this.getUserShiftById();
    let roleid = this.secureStore.get("USINFO").role_id;
    console.log("roleid :", roleid);
    if (true) {
      this.isRoleID = false;
    }
    this.userInfo = this.secureStore.get("USINFO");
    // this.getCinemas(this.userInfo.cinema_id);
    // this.getCinemas();
    // this.getShiftsList();
    // if (this.userInfo.cinema_id == 0) {
    //   this.getUsersList();
    // }
  },
  methods: {
    onSearchStore: function () {
      if (this.searchStore && this.searchStore.length > 0) {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy.filter(
          (x) => {
            // let full_name = `${x.first_name} ${x.last_name}`
            if (
              x.sm_store_name
                .toLowerCase()
                .includes(this.searchStore.toLowerCase())
              // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.storeManagementsLevels = this.storeManagementsLevelsCopy;
      }
    },
    onSearchShift: function () {
      if (this.searchShift && this.searchShift.length > 0) {
        this.Shifts = this.ShiftsCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.shift_name.toLowerCase().includes(this.searchShift.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Shifts = this.ShiftsCopy;
      }
    },
    clear_us_start_date() {
      this.users_shifts.us_start_date = "";
    },
    clear_us_end_date() {
      this.users_shifts.us_end_date = "";
    },
    getUserShiftById: function () {
      let payload = {
        us_id: this.users_shifts.us_id,
      };
      MasterService.GetUserShiftDetails(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            // console.log('obj :', obj);
            this.users_shifts = data.Records[0];
            this.users_shifts.us_start_date = new Date(obj.us_start_date);
            this.users_shifts.us_end_date = new Date(obj.us_end_date);
            this.getUsersList(obj.us_cinema_id, obj.user_id);
            console.log("obj.us_cinema_id :", obj.us_cinema_id);
            this.getCinemas(obj.us_cinema_id);
            this.getShiftsList(obj.shift_id);
            // this.getStoreManagementList(
            //   obj.us_cinema_id,
            //   obj.store_management_id
            // );

            // this.getConcessionLevelList(
            //   obj.us_cinema_id,
            //   obj.concession_level_id
            // );
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getCinemas: function (cinema_id) {
      console.log("cinema_id :", cinema_id);
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      MasterService.GetCinemas({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
                this.users_shifts.cinema_id = x.cine_id;
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onSelectStore: function (store) {
      this.selectedStoreLevel = store.sm_store_name;
      this.users_shifts.sm_id = store.sm_id;
    },
    getStoreManagementList(cinema_id, store_management_id) {
      this.storeManagementsLevels = [];
      this.selectedStoreLevel = "";
      this.users_shifts.sm_id = store_management_id;
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.storeManagementsLevels = data.Records;
            this.storeManagementsLevelsCopy = data.Records;
            this.storeManagementsLevels.map((x) => {
              if (x.sm_id == store_management_id) {
                this.selectedStoreLevel = x.sm_store_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getConcessionLevelList: function (cinema_id, cl_id) {
      this.Concessions = [];
      let payload = {
        tableName: "ms_concession_levels",
        cinema_id: cinema_id,
        cl_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          // console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.Concessions = data.Records;
            this.Concessions.map((x) => {
              if (x.cl_id === cl_id) {
                this.onSelectConcession(x);
              }
            });
          } else {
            // Show Error Message:
            console.log(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log(error);
        });
    },
    onSelectConcession: function (concession) {
      this.selected.Concession = concession.cl_name;
      this.users_shifts.concession_level_id = concession.cl_id;
    },

    getShiftsList: function (shift_id) {
      this.Shifts = [];
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_shifts",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Shifts = data.Records;
            this.ShiftsCopy = data.Records;
            this.Shifts.map((x) => {
              if (x.shift_id == shift_id) {
                this.selectedShift = x.shift_name;
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    getUsersList: function (cinema_id, user_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "users"
      // });
      // if (cinema_id) {
      //   body[cinema_id] = cinema_id;
      // }
      MasterService.GetUsers({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;
            this.Users.map((x) => {
              if (x.user_id == user_id) {
                this.selectedUser = x.first_name + x.last_name;
                // this.getCinemas(x.cinema_id);
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onSelectCinema: function (event, cinema) {
      this.selectedCinema = cinema.cine_name;
      this.users_shifts.cinema_id = cinema.cine_id;
      this.getUsersList(cinema.cine_id);
    },
    onSelectUser: function (event, user) {
      this.selectedUser = user.first_name + " " + user.last_name;
      this.users_shifts.user_id = user.user_id;
    },
    onSelectShift: function (event, shift) {
      this.selectedShift = shift.shift_name;
      this.users_shifts.shift_id = shift.shift_id;
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.submitted = false;
      this.users_shifts = {
        concession_level_id: "",
        user_id: "",
        shift_id: "",
        us_start_date: "",
        us_end_date: "",
        us_is_active: true,
      };
      (this.selectedCinema = ""),
        (this.selectedUser = ""),
        (this.selectedStoreLevel = ""),
        (this.selectedShift = "");
    },
    handleSubmit(flag) {
      this.submitted = true;

      const {
        cinema_id,
        sm_id,
        user_id,
        shift_id,
        us_start_date,
        us_end_date,
      } = this.users_shifts;

      console.log({
        cinema_id,
        sm_id,
        user_id,
        shift_id,
        us_start_date,
        us_end_date,
      });

      if (
        !cinema_id ||
        !user_id ||
        !shift_id ||
        !us_start_date ||
        !us_end_date
      ) {
        return;
      }

      this.$validator.validate().then((valid) => {
        // console.log("Valid :", valid);
        if (valid) {
          this.btenable = true;
          let body = {
            ...this.users_shifts,
          };
          MasterService.UpdateUserShifts(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.resetHandler();
                if (flag) {
                  this.$router.push({
                    path: "/cinema-manager/user-shifts",
                  });
                }
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/UsershiftsComponents/editUserShifts.vue